import { render, staticRenderFns } from "./seeReformPrototype.vue?vue&type=template&id=518bcbc5"
import script from "./seeReformPrototype.vue?vue&type=script&lang=js"
export * from "./seeReformPrototype.vue?vue&type=script&lang=js"
import style0 from "./seeReformPrototype.vue?vue&type=style&index=0&id=518bcbc5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports